import { ajax } from 'rxjs/ajax';

const formSubmitUrl = 'https://formsubmit.co/ajax/sungyeol.choi@gmail.com';

export const postQuoteRequestForm = (form) => {
  return ajax({
    url: formSubmitUrl,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: {
      message: 'hello world!',
      ...form
    } 
  });
}

export default { postQuoteRequestForm };



// WEBPACK FOOTER //
// ./src/services/formSubmit.js